import script from "./VPSView.vue?vue&type=script&lang=ts&setup=true"
export * from "./VPSView.vue?vue&type=script&lang=ts&setup=true"

import "./VPSView.vue?vue&type=style&index=0&id=5cb6848a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb6848a"]])

export default __exports__